import { Base } from "ui/Scripts/source/framework/base";

interface IUnitDefaultHandlersNodeSave {
    id: string;
    userCodes: string[];
    notifyUserCodes: string[];
}

export class UnitDefaultHandlersNodeSave implements IUnitDefaultHandlersNodeSave {
    id: string;
    userCodes: string[];
    notifyUserCodes: string[];

    constructor();
    constructor(obj: IUnitDefaultHandlersNodeSave);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.userCodes = obj && obj.userCodes || [];
        this.notifyUserCodes = obj && obj.notifyUserCodes || [];
    }

    static getSortedUnitDefaultHandlersNodeSaves(src: IUnitDefaultHandlersNodeSave[]): IUnitDefaultHandlersNodeSave[] {
        const result = src.slice(0);
        result.sort((a: IUnitDefaultHandlersNodeSave, b: IUnitDefaultHandlersNodeSave) => {
            if ((!a) && (!b)) return 0;
            if (!a) return 1;
            if (!b) return -1;
            if (Base.isNullOrUndefined(a) && Base.isNullOrUndefined(b)) return 0;
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
        });
        return result;
    }
}